import React, { useState, useEffect, useContext } from 'react';
import { uploadFile, updatekyc , worldCheckHits , sanctionIoHits, createNotification, createKycComment, getkycRiskAssessment, createKycNestedSanctionComment, sendEmailNotification, getkyc, getkycAll, updatekycStatus,updateKycAmlVideo,  createkycRiskAssessment, updatekycRiskAssessment, getAllUsers, frontEndBaseURL,updatekycRiskById} from "../../../API/Api" 
import { Card } from '../../shared/utils';
import QuestionCard from './QuestionCard'; 
// import FormStatusEnum from '../../../data/FormStatusEnum'
import { DateTime } from "luxon"
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import {ListB, ListC, ListD, highRiskJurisdictions, transparencyInternational } from '../../../data/RiskCountries'
import SanctionsScreeningSectionLaw from './SanctionsScreeningSection_Law'
import SubmissionCardLaw from './SubmissionCard_Law';
import { jwtDecode } from "jwt-decode";
import { TokenContext
  
 } from '../../../App';

 import { RiskLevel } from './enums';
import CustomTooltip from './CustomTooltip';

const _KycVideoForm_Law = ({ clientFormId, userType, readOnly, currentUrl, formAuthority}) => {
  const [encodedAccessToken] = useContext(TokenContext) 
  const decodedToken = jwtDecode(encodedAccessToken)
  const [kycData, setKycData] = useState(
  ); 
  const [loading, setLoading] = useState(true);
  const [displayedUsers, setDisplayedUsers] = useState([]);
  const [allreviewers, setAllreviewers] = useState([])
  const userRole = decodedToken.role
  const [proceedStatus, setProceedStatus] = useState(false); 
  const [mandatoryFieldError, setMandatoryFieldError] = useState({
    videoVerification:'',  
    explanationOfReasons:''
    });  
    const [selectedEmail, setSelectedEmail] = useState(''); // 新增状态：存储选中的邮箱
  useEffect(() => {
    const fetchData = async () => {
      try {
        const currentKycData = await getkyc(clientFormId).then(response => response.data) 
        setKycData(currentKycData)
        // 设置默认选中的邮箱
        if (currentKycData?.type === "individual") {
          setSelectedEmail(currentKycData.email);
        } else if (currentKycData?.type === "entity" && currentKycData?.details?.connectedParty?.length > 0) {
          setSelectedEmail(currentKycData.details.connectedParty[0].email);
        }
        setLoading(false);
      } catch(e) {
        console.error(e)
        toast.error(`Something went wrong...`);
      } 
    } 
  
    fetchData()
  }, []); 
  const emailiInvitation = async (e) => { 
    if (!selectedEmail) {
      toast.error('Please select the contact person first');
      return;
    }
    
    sendEmailNotification({
        email: selectedEmail.split('/')[0],
        subject: "Video Verification Invitation - iCompass KYC Platform",
        message: `<div style="max-width: 500px; margin: 0 auto; border: 2px solid #FF8C00; padding: 20px; text-align: left;">
                    <h2 style="color: #2c5282; margin-bottom: 15px;">Video Verification Invitation</h2>
                    <p>Dear ${kycData.name},</p>
                    
                    <p>You have been invited to complete video verification on the iCompass KYC Platform.</p>
                    
                    <p style="margin: 20px 0;">
                      Please click the following link to begin your video verification session:<br/>
                      <a href="https://whereby.com/information/embedded" style="color: #4299e1; text-decoration: underline;">Start Video Verification</a>
                    </p>
                    
                    <p>This verification is required to complete your KYC process.</p>
                    
                    <div style="text-align: center; margin: 25px 0;">
                      <img src="https://icompass-backend-dev-fhagh5hccpf2ebh9.southeastasia-01.azurewebsites.net/images/from_icompass" 
                           alt="iCOMPASS logo" 
                           style="width: 100px; max-width: 100%;">
                    </div>
                    <p style="font-size: 0.9em; color: #718096; margin-top: 25px;">
                      <em>Please do not reply to this automated email.</em><br/>
                    </p>
                </div>`
    });
    toast.success(`Invitation email sent successfully.`);
};
 const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setKycData(prev => ({
      ...prev,
      details: {
        ...prev.details,
        [name]: value
      }
    }));
  }
const handleSaveForm = async (e) => {
  let requiredFields = ["videoVerification"];
  if(kycData?.details?.videoVerification === 'no') {
    requiredFields = ["videoVerification", "explanationOfReasons"];
  }
  
  // let allRequiredFieldsFilled = true;
  // let newMandatoryFieldError = {...mandatoryFieldError};
  
  // requiredFields.forEach(field => {
  //   if (!kycData?.details?.[field]) { 
  //     allRequiredFieldsFilled = false;
  //     newMandatoryFieldError[field] = true;
  //   } else {
  //     newMandatoryFieldError[field] = false;
  //   }
  // });
  
  // setMandatoryFieldError(newMandatoryFieldError);
  
  // if (!allRequiredFieldsFilled) {
  //   toast.info("Please fill in the required fields");
  //   return;
  // }
  
  try {
    await updateKycAmlVideo({
            id: clientFormId,
            maxPage: 3,  // 必填
            videoVerification: kycData?.details?.videoVerification, 
            explanationOfReasons: kycData?.details?.explanationOfReasons 
    });
    setProceedStatus(true);
    toast.success(`Assessment saved!`);
  } catch (error) {
    toast.error("Failed to save assessment");
    console.error(error);
  }
}
const clickProceed = async (e) => {
    if (currentUrl !== '/form/kyc-aml') {
      window.location.href = `/kyc-aml/form?clientFormId=${clientFormId}&page=3`;
    } else {
      window.location.reload();
    }

}
    
  if (loading) {
    return <div className='h-screen w-screen'> Loading... </div>  
  }  
     
  return (
    <div className="max-w-6xl mx-auto">
    <Card className="mt-4">
      <div > {/* 添加顶部边距 */}
        <table className="w-full border-collapse border border-gray-300 shadow table-auto mt-4"> {/* 添加表格顶部边距 */}
          <thead>
            <tr className="bg-gray-300 text-left">
              <th className="p-2 text-center">Name</th>
              <th className="p-3 text-center">Role/Relationship</th>
              <th className="p-2 text-center">Email</th>
              <th className="p-2 text-center">Choose</th>
            </tr>
          </thead>
          
          {kycData?.type === "individual" && (
            <tbody>
              <tr className="bg-green-50 hover:bg-green-100">
                <td className="p-2 w-2/12 text-center">{kycData.name}</td>
                <td className="p-3 w-2/12 text-center">个人</td>
                <td className="p-2 w-2/12 text-center">{kycData.email}</td>
                <td className="p-2 w-1/12 text-center">
                  <input 
                    type="checkbox" 
                    checked={selectedEmail === kycData.email}
                    onChange={() => setSelectedEmail(kycData.email)}
                    className="h-4 w-4"
                    disabled={readOnly} 
                  />
                </td>
              </tr>
            </tbody>
          )}
          
          {kycData?.type === "entity" && (
            <tbody>
              {kycData?.details?.connectedParty.map((party, index) => (
                <tr key={index+"-role"} className={index % 2 === 0 ? 'bg-green-50 hover:bg-green-100' : 'bg-white hover:bg-green-100'}>
                  <td className="p-2 w-2/12 text-center">{party.name}</td>
                  <td className="p-3 w-2/12 text-center">
                    {party.authorisedSignatory && <p>Authorised Signatory</p>}
                    {party.connectedParty && <p>Connected Party</p>}
                    {party.ultimateBeneficialOwner && <p>Ultimate Beneficial Owner</p>}
                  </td>
                  <td className="p-2 w-2/12 text-center">{party.email}</td>
                  <td className="p-2 w-1/12 text-center">
                    <input 
                      type="checkbox" 
                      checked={selectedEmail === party.email}
                      onChange={() => setSelectedEmail(party.email)}
                      className="h-4 w-4"
                      disabled={readOnly} 
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
        
        <div className="flex justify-end mt-4"> {/* 按钮靠右并添加顶部边距 */}
          <button 
            onClick={emailiInvitation} 
            disabled={readOnly} 
            className="bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600"
          >
            Trigger email invitation
          </button>
        </div>
        <div className={kycData?.details?.videoVerification === 'yes' ? "border p-2 mt-4" : "p-2 mt-4"}>
          <label className="block font-medium text-gray-700 mb-1">Has the video verification been completed successfully?<i className='text-red-600'>*</i></label>
          <div className="mt-1 flex items-center">
            <input maxLength={800} disabled={readOnly} type="radio" id="pepYes" onChange={handleInputChange} name="videoVerification" value="yes"  checked={kycData?.details?.videoVerification === 'yes'} className="mr-1 w-4 h-4" />
            <label htmlFor="pepYes" className="mr-2">Yes</label>
            <input maxLength={800} disabled={readOnly} type="radio" id="pepNo" onChange={handleInputChange} name="videoVerification" value="no"  checked={kycData?.details?.videoVerification === 'no'} className="mr-1 w-4 h-4"/>
            <label htmlFor="pepNo">No</label>
          </div>

          {kycData?.details?.videoVerification === 'no' && (
                <div className='mt-1'> 
                <textarea maxLength={800} disabled={readOnly} 
                    value={kycData?.details?.explanationOfReasons} 
                    onChange={handleInputChange}
                    name='explanationOfReasons' placeholder="Please fill in the reason statement" 
                    className="block w-11/12 mb-3 p-1.5 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500" rows={3}>
                  </textarea>
                  {mandatoryFieldError.explanationOfReasons && <p style={{ color: 'red' }}>Please fill in the reason statement</p>}
                </div>
            )}
        </div>
        <div className="flex justify-end mt-4"> {/* 按钮靠右并添加顶部边距 */}
          {proceedStatus==false&&(
            <button 
                onClick={handleSaveForm} 
                disabled={readOnly} 
                className="bg-green-500 text-white font-semibold py-2 px-4 rounded-md hover:bg-green-600"
            >
                save
            </button>   
            )}
          {proceedStatus==true&&(
            <button 
                onClick={clickProceed} 
                className="bg-white text-gray-800 font-semibold py-2 px-4 rounded-md border border-gray-300 hover:bg-gray-100 transition-colors"
            >
                proceed
            </button>
          )}
        </div>
      </div>
    </Card>
    </div>
  );
};

export default _KycVideoForm_Law
